import { useCallback } from 'react';
import useSWR from 'swr';
import { CACHE_KEYS } from '../utils/CacheUtils.js';
export function useAdminEntity(client, reference) {
    const fetcher = useCallback(([_action, reference]) => fetchEntity(client, reference), [client]);
    const { data, error } = useSWR(reference ? CACHE_KEYS.adminEntity(reference) : null, fetcher);
    // useDebugLogChangedValues('useAdminEntity changed values', { data, error });
    return { entity: data, entityError: error };
}
async function fetchEntity(client, reference) {
    const result = await client.getEntity(reference);
    if (result.isError()) {
        throw result; // throw result, don't convert to Error
    }
    return result.value;
}
//# sourceMappingURL=useAdminEntity.js.map